import Relay from 'react-relay';

export default class FollowUserMutation extends Relay.Mutation {
  static fragments = {
    user: () => Relay.QL`
      fragment on User {
        id
      }
    `,
    socialCounters: () => Relay.QL`
      fragment on UserSocialCounters {
        id
        numFollowers
      }
    `,
    viewerMetadata: () => Relay.QL`
      fragment on UserViewerMetadata {
        id
        viewerIsFollowing
      }
    `,
  };

  static defaultProps = {
    action: 'follow',
  };

  getMutation() {
    if (this.props.action === 'follow') {
      return Relay.QL`mutation {followUser}`;
    }
    return Relay.QL`mutation {unfollowUser}`;
  }

  getFatQuery() {
    if (this.props.action === 'follow') {
      return Relay.QL`
        fragment on FollowUserPayload {
          user {
            followers
          }
          socialCounters {
            numFollowers
          }
          viewerMetadata {
            viewerIsFollowing
          }
        }
      `;
    }
    return Relay.QL`
      fragment on UnfollowUserPayload {
        user {
          followers
        }
        socialCounters {
          numFollowers
        }
        viewerMetadata {
          viewerIsFollowing
        }
      }
    `;
  }

  getOptimisticResponse() {
    const { action } = this.props;

    const numFollowers = action === 'follow'
      ? this.props.socialCounters.numFollowers + 1
      : this.props.socialCounters.numFollowers - 1;

    const viewerIsFollowing = action === 'follow';

    return {
      socialCounters: {
        id: this.props.socialCounters.id,
        numFollowers,
      },
      viewerMetadata: {
        id: this.props.viewerMetadata.id,
        viewerIsFollowing,
      },
    };
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        socialCounters: this.props.socialCounters.id,
        viewerMetadata: this.props.viewerMetadata.id,
        user: this.props.user.id,
      },
    }];
  }

  getVariables() {
    return {
      id: this.props.user.id,
    };
  }
}



// WEBPACK FOOTER //
// ../src/client/apps/shops/mutations/FollowUserMutation.js